module.exports = __webpack_public_path__ + "static/CollectiveRooftopTerrace-ab673fb0597b798b73fa51e2a993ccc9.jpg";